var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgOnlineLogo = function SvgOnlineLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.1,
    fill: "#00C3FF",
    cx: 37,
    cy: 37,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#00C3FF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 53.667c-9.205 0-16.667-7.462-16.667-16.667 0-9.205 7.462-16.667 16.667-16.667 9.205 0 16.667 7.462 16.667 16.667 0 9.205-7.462 16.667-16.667 16.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.333 22H32a47.373 47.373 0 000 30h-1.667M42 22a47.373 47.373 0 010 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 43.667V42a47.373 47.373 0 0030 0v1.667M22 32a47.373 47.373 0 0130 0"
  })))));
};
export default SvgOnlineLogo;